import { SnackbarKey, closeSnackbar } from "notistack"
import { FC } from "react"

import AppButton from "./appButton"

interface DismissButtonProps {
    snackbarId: SnackbarKey
}

/**
 * Dismiss button for use in the global SnackbarProvider.
 */
const SnackbarDismiss: FC<DismissButtonProps> = ({ snackbarId }) => (
    <AppButton
        type="button"
        onClick={() => closeSnackbar(snackbarId)}
        sx={{ color: "white" }}
    >
        Dismiss
    </AppButton>
)

export default SnackbarDismiss
